import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { io } from "socket.io-client";

import Highlight from "react-highlight.js";

const formatLog = (str, title = false) => {
  try {
    const result = JSON.parse(str);
    if (title) {
      return result[0];
    }
    return result;
  } catch (err) {
    return str;
  }
};

const serverUrl = "https://diy-log-server.herokuapp.com";

// const serverUrl = "http://localhost:5000";
const socket = io(serverUrl);

const LogsTable = () => {
  let { secret } = useParams();
  socket.on("connect", () => {
    socket.emit("room", secret);
  });

  const [userFilter, setUserFilter] = useState("");
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    socket.on("newLog", (log) => {
      setLogs((logs) => [log, ...logs]);
    });
  }, []);
  useEffect(() => {
    socket.on("logs", (logs) => {
      console.log("on logs", logs);
      setLogs(logs);
    });
  }, []);
  return (
    <>
      <h1>Logs</h1>
      <code className="filter">
        <label>Filter by user id </label>
        <select onChange={(e) => setUserFilter(e.target.value)}>
          <option value={""}>No Filter</option>
          {[...new Set(logs.map((el) => el.userId))].map((el) => (
            <option key={el} value={el}>
              {el}
            </option>
          ))}
        </select>
      </code>
      <div className="logsTable">
        {logs
          .filter((el) => {
            if (userFilter.length > 0) {
              return el.userId === userFilter;
            } else {
              return true;
            }
          })
          .map((el) => (
            <Accordion className={"logrow"} key={el._id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                className={"summary"}
              >
                <pre>
                  <span className={"timestamp"}>{el.date} </span>
                  <span className={"userId"}>{el.userId} </span>
                  <span>{JSON.stringify(formatLog(el.logMessage, true))}</span>
                </pre>
              </AccordionSummary>
              <AccordionDetails className={"details"}>
                <Highlight language={"JSON"}>
                  {JSON.stringify(formatLog(el.logMessage), null, 2)}
                </Highlight>
              </AccordionDetails>
            </Accordion>
          ))}
      </div>
    </>
  );
};

export default LogsTable;
